// Bridge between the native shell and the Rails session for push-notification registration.
//
// The FCM token only exists in native code, but the endpoint that stores it is CSRF
// protected — and deliberately so, since forging that request would let an attacker point
// your notifications at their phone. Posting from the page solves it: this runs in the
// authenticated origin and has the CSRF token, so no protection has to be relaxed.
//
// The Android shell calls these through evaluateJavascript once Firebase hands it a token:
//
//   window.tomoRegisterDeviceToken("<fcm-token>", "android")
//   window.tomoUnregisterDeviceToken("<fcm-token>")
//
// Both are no-ops in a normal browser, where nothing ever calls them.

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.content : null
}

function postDeviceToken(method, token, platform) {
  if (!token) return Promise.resolve(false)

  const csrf = csrfToken()
  // Signed-out pages are rendered without a CSRF meta tag; there is no session to attach
  // the device to yet, so the shell will retry after the user signs in.
  if (!csrf) return Promise.resolve(false)

  const body = platform ? { token: token, platform: platform } : { token: token }

  return fetch("/device_tokens", {
    method: method,
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrf,
      Accept: "application/json"
    },
    credentials: "same-origin",
    body: JSON.stringify(body)
  })
    .then((response) => response.ok)
    .catch(() => false)
}

window.tomoRegisterDeviceToken = function (token, platform) {
  return postDeviceToken("POST", token, platform || "android")
}

window.tomoUnregisterDeviceToken = function (token) {
  return postDeviceToken("DELETE", token, null)
}
